import { VStack, Text, Heading, SimpleGrid, Image } from '@chakra-ui/react'

import { useFormikContext } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { RegisterAgencyValues } from '..'

const Confirm: React.FC<{
  isTabletOrMobile?: boolean
}> = ({ isTabletOrMobile }) => {
  const { values } = useFormikContext<RegisterAgencyValues>()
  const { t } = useTranslation()
  return (
    <VStack spacing={8} my={10} alignItems="flex-start">
      <Heading>{t('signup.agency.confirm')}</Heading>

      <SimpleGrid rowGap={0} fontSize="sm" columnGap={8} columns={isTabletOrMobile ? 0 : 2}>
        <VStack textAlign="left" alignItems="flex-start">
          <Heading size="md">{t('signup.agency.agency_info')}</Heading>
          <Text>
            {t('signup.agency.name_label')}: <b>{values.agencyName}</b>
          </Text>
          <Text>
            {t('signup.agency.website')}: <b>{values.agencyWebsite}</b>
          </Text>
          <Text>
            {t('signup.agency.email')}: <b>{values.agencyEmail}</b>
          </Text>
          <Text>
            {t('signup.agency.phone_number')}: <b>{values.agencyPhone}</b>
          </Text>
          <Text>
            {t('signup.agency.address')}: <b>{values.agencyAddress}</b>
          </Text>
          <Text>
            {t('signup.agency.description')}: <b>{values.agencyDescription}</b>
          </Text>
          {values.agencyLogo && (
            <Image
              py={5}
              w={44}
              src={values.agencyLogo?.format?.thumbnail.url || values.agencyLogo.url}
            />
          )}
        </VStack>
        <VStack textAlign="left" alignItems="flex-start">
          <Heading size="md">{t('signup.agency.admin_info')}</Heading>
          <Text>
            {t('signup.agency.first_name_label')}: <b>{values.adminFirstName}</b>
          </Text>
          <Text>
            {t('signup.agency.last_name_label')}: <b>{values.adminLastName}</b>
          </Text>
          <Text>
            {t('signup.agency.email')}: <b>{values.adminEmail}</b>
          </Text>
          <Text>
            {t('signup.agency.phone_number_label')}: <b>{values.adminPhone}</b>
          </Text>
          <Text>
            {t('signup.agency.agent_number')}: <b>{values.adminAgentNumber}</b>
          </Text>
          {values.adminProfilePicture && (
            <Image
              py={5}
              w={44}
              src={
                values.adminProfilePicture?.format?.thumbnail.url || values.adminProfilePicture.url
              }
            />
          )}
        </VStack>
      </SimpleGrid>
    </VStack>
  )
}

export default Confirm
